import React, {Component} from "react";
import Sort from "../../../helpers/Sort";
import Event from "./Event";
import EventHeader from "./EventHeader";
import Loading from "../../../components/Loading";
import EventHelper from "../../../helpers/EventHelper";
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {getLive, toggleFavorite} from "../../../redux/actions/live";
import _ from "lodash";

class Events extends Component {
	static defaultProps = {
		updateTime : 1000
	};

	static propTypes = {
		updateTime : PropTypes.number
	};

	intervalId = 0;

	constructor(props) {
		super(props);
		this.loadData = this.loadData.bind(this);
	}

	componentWillMount() {
		this.intervalId = setInterval(this.loadData, this.props.updateTime);

		if ( !this.props.live.isAlreadyLoaded ) {
			this.loadData();
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		const isLiveEquals = JSON.stringify(this.props.live) === JSON.stringify(nextProps.live);
		const isFilterEquals = this.props.filter === nextProps.filter;

		return !(isLiveEquals && isFilterEquals);
	}

	componentWillUnmount() {
		clearInterval(this.intervalId);
	}

	loadData() {
		this.props.onGetLive();
	}

	componentWillReceiveProps(nextProps) {
		if ( !nextProps.live.fetching ) {
			nextProps.favorites.forEach((fav) => {
				const event = _.find(nextProps.live.events, (event) => {return event.id === fav});
				if ( event === undefined ) {
					this.props.toggleFavorite(fav);
				}
			});
		}
	}

	render() {
		if ( this.props.live.fetching ) {
			return <Loading/>;
		}

		const {isTopLive} = this.props;
		const {sports, events, results, leagues} = this.props.live;

		const filter = this.props.filter;

		if ( sports.length === 0 ) {
			return <div className="message info"><span>В данный момент нет событий Live</span></div>;
		}

		let sortedSports = _.sortBy(sports, i => i.name);

		// если активен фильтр по виду спорта
		if ( filter.sport.sportId !== 0 ) {
			sortedSports = EventHelper.sportLiftUp(sports, filter.sport.sportId);
		}

		let fEvents = events;
		if ( filter.league.id !== 0 ) {
			sortedSports = sports.filter((s) => {return +s.id === filter.sport.sportId});
			fEvents = events.filter((e) => {return +e.league_id === filter.league.id});
		}

		if ( isTopLive ) {
			fEvents = events.filter((e) => {return +e.is_top === 1});
			const issetSports = _.uniq(fEvents.map((event) => event.sport_id));
			sortedSports = sports.filter((s) => {return issetSports.indexOf(s.id) !== -1});
			sortedSports = _.sortBy(sortedSports, i => i.name);
		}

		const data = sortedSports.map((sport) => {
			let eventsBySport = fEvents.filter((event) => {return event.sport_id === sport.id});
			eventsBySport.sort(Sort.orderByTime);

			const dataEvents = [];

			eventsBySport.forEach((event) => {
				const description = EventHelper.parseDescription(event.description);
				const tv = description.getTv();
				const video_online = description.getVideoOnline();
				const tracker = description.getTracker();

				if ( filter.tv && tv === '' ) {
					return;
				}

				if ( filter.video_online && video_online === '' ) {
					return;
				}

				if ( filter.tracker && tracker === '' ) {
					return;
				}

				dataEvents.push(
					<Event key={event.id}
					       description={description}
					       event={event}
					       filter={filter}
					       league={_.find(leagues, (league) => {return league.id === event.league_id})}
					       results={results.filter((result) => {return result.event === event.id})}/>
				);
			});

			if (dataEvents.length === 0) {
				return null;
			}

			return (
				<div key={`live-sport-${sport.id}`} className="events__table table-div">
					<EventHeader events={eventsBySport} sport={sport}/>

					<div className="tbody">
						{dataEvents}
					</div>
				</div>
			)
		});

		return (
			<div className="events">
				{data}
			</div>
		);
	}
}

export default connect(
	state => ({
		favorites : state.favorites,
		live      : state.live,
		filter    : state.filter
	}),
	dispatch => ({
		toggleFavorite : (data) => {
			dispatch(toggleFavorite(data));
		},
		onGetLive      : () => {
			dispatch(getLive());
		}
	})
)(Events);


// WEBPACK FOOTER //
// ./src/app/pages/Main/Events/Events.js